import React, { Component } from "react";
import { Dropdown } from "semantic-ui-react";
import "../style/addProduct.scss";
import {offersData, discountData, thresholdData} from '../Utils/Constants';
import {callAPI} from '../Utils/Api';
import ErrorPopup from "../components/ErrorPopup";

const sellerData = {
  SELLER_ID: "2816",
  SELLER_UUID: "4f39a03c-4ee0-40b3-9f59-949022231802",
}

export default class AddProduct extends Component {
  state = {
    productId : null,
    productDescription: "",
    isProductDescription : false,
    offersValue: null,
    discountValue: "",
    isDiscountValue : false,
    discountType: null,
    thresholdType : null,
    thresholdValue : "",
    isThresholdValue : false,
    isErrorPopup : false
  };

  componentDidMount(){
      const productParam = new URLSearchParams(window.location.search);
      if (productParam.has("product_id")){
        const productId = productParam.get('product_id');
        this.setState({productId});
        this.getProduct(productId);
      }
  }

  handleSubmit = (e) => {
    const {productId, productDescription, discountValue, thresholdValue, discountType, thresholdType } = this.state;
    e.preventDefault();
    productDescription == '' ? this.setState({isProductDescription : true}) : this.setState({isProductDescription : false});
    discountValue == '' ? this.setState({isDiscountValue : true}) : this.setState({isDiscountValue : false});
    thresholdValue == '' ? this.setState({isThresholdValue : true}) : this.setState({isThresholdValue : false});
    if (productDescription != '' && discountValue != '' && thresholdValue != ''){
        const _giftDTO = {
            id:  productId, // id of the gift (null for creation)
            value: discountValue, //reduction amount
            description: productDescription.toUpperCase(), // name of the advantage
            threshold: thresholdValue, //number of points
            discountType: discountType.toUpperCase(), //discount type
            thresholdType: thresholdType.toUpperCase(), // Threshold type
          };
        const _productData = {
            sellerId: parseInt("2816"), 
            sellerName: "SMILE", 
            giftDTO: _giftDTO,
        }
       this.saveProduct(_productData);
    }
  }

  getProduct = async (productId) => {
    const response = await callAPI(
      `https://prod.winitout.com/api/bienvenus/gifts/${productId}`,
      'GET',
      sellerData,
      null,
      null
    );
    if (response.type === 'error' || response.type === 'other error') {
     this.setState({isErrorPopup : true});
      return;
    } else {
      const {description, value, threshold, discountType, thresholdType} = response.data.giftDTO
      this.setState({productDescription : description, offersValue : "Une réduction",  discountValue : value, discountType : discountType.toLowerCase() == "value" ? "value" : "percent", thresholdValue : threshold, thresholdType : thresholdType.toLowerCase() == "basket" ? "Basket" : thresholdType.toLowerCase() == "points" ? "Points" : "Orders" });
      this.setState({isErrorPopup : false});
    }
  }

  saveProduct = async (productData) => {
      const response = await callAPI(
        'https://prod.winitout.com/api/bienvenus/giftss/',
        'POST',
        sellerData,
        productData,
        null
      );
      if (response.type === 'error' || response.type === 'other error') {
        this.setState({isErrorPopup: true});
        return;
      } else {
       this.props.history.push('/login');
       this.setState({isErrorPopup: false});
      }
  }

  render() {
    const {productDescription, isProductDescription, offersValue, isThresholdValue, isDiscountValue,  discountValue, discountType, thresholdType, thresholdValue } = this.state;
    return (
      <React.Fragment>
      <div className="dashboard">
        <main className="main" id="main">
          <p className="titleHeader">Créez votre avantage !</p>
          <p className="titleChild">Paramétrez le</p>
          <input
            type="text"
            className={`form-control mb-3 ${isProductDescription && "validate-error"}`}
            placeholder="Nom de l'avantage"
            value={productDescription}
            onChange={(e) => {
              this.setState({ productDescription: e.target.value });
            }}
          />

          <div className="form-group form-inline nopad mb-3">
            <label>J’offre</label>
            <div className="custom-select">
              <Dropdown
                onChange={(e, { value }) => {
                  this.setState({ offersValue: value });
                }}
                options={offersData}
                placeholder="Sélectionner"
                selection
                value={offersValue}
              />
            </div>
          </div>

          {offersValue && (
            <div className="form-group form-inline nopad mb-3" id="discountDiv">
              <label>de</label>
              <input type="tel" className={`customInputField ${isDiscountValue && "validate-error"}`} placeholder="00" value={discountValue} onChange={(e) => {this.setState({discountValue: e.target.value})}} />
              <div className="custom-select discountSelection">
                <Dropdown
                  onChange={(e, { value }) => {
                    this.setState({ discountType: value });
                  }}
                  options={discountData}
                  placeholder="Sélectionner"
                  selection
                  value={discountType}
                />
              </div>
            </div>
          )}

          {
              discountType &&
              <div className="form-group form-inline nopad mb-3" id="thresholdDiv">
              <label>pour</label>
              <div className="custom-select" style={{marginLeft: "23px"}}>
                <Dropdown
                  onChange={(e, { value }) => {
                    this.setState({ thresholdType: value });
                  }}
                  options={thresholdData}
                  placeholder="Sélectionner"
                  selection
                  value={thresholdType}
                />
              </div>
            </div>
          }

          {
              thresholdType &&
            <div className="form-group form-inline nopad mb-3" id="thresholdInputDiv">
            <label>de</label>
            <input
              id="thresholdValue"
              type="tel"
              className={`customInputField ${isThresholdValue && "validate-error"}`}
              placeholder="000"
              value={thresholdValue}
              onChange={(e) => this.setState({thresholdValue: e.target.value})}
              style={{marginLeft: "38px"}}
            />
            <label id="thresholdText" style={{marginLeft: "8px"}}>€</label>
          </div>
          }

          <div className="sticky-bottom">
            <button
              type="button"
              className="btn btn-primary"
              onClick={this.handleSubmit}
            >
              <span className="icon start icon-md icon-save"></span>
              Sauvegarder
            </button>
          </div>
        </main>
      </div>
     { this.state.isErrorPopup && <ErrorPopup error={this.state.isErrorPopup} /> }
    </React.Fragment>
    );
  }
}
